var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"return",on:{"click":function($event){return _vm.goTo('/')}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.arrowLeft,"alt":""}})]),_c('iframe',{staticClass:"iframe",attrs:{"id":"myIframe","src":"https://leisure.intermaps.com/maps/linz","title":"map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }